(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabFirmware', TabFirmware);

    TabFirmware.$inject = ['$resource'];

    function TabFirmware ($resource) {
        var resourceUrl =  'api/tab-firmware/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'load': {
                url:'api/tab-firmware/inactive',
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();
